export const pageWrap = {
  marginRight: "20px",
  marginLeft: "20px",
};

export const fullWidthTable = {
  width: "100%",
};

export const headerCell = {
  textAlign: "left",
  width: "70%",
  borderLeft: "1px solid black",
  borderTop: "1px solid black",
  borderBottom: "1px solid black",
  borderRight: "1px solid black",
  borderCollapse: "collapse",
  padding: "8px",
};

export const headerTitle = {
  display: "flex",
  justifyContent: "center",
  paddingBottom: "10px",
  fontSize: 20,
  fontWeight: 600,
};

export const tableWrap = {
  borderCollapse: "collapse",
  marginTop: "8px",
};

export const collapseFullWidth = {
  borderCollapse: "collapse",
  width: "100%",
};

export const summaryFont = {
  fontSize: "18px",
};

export const summaryLabel = {
  display: "inline",
  fontWeight: 600,
};

export const columnHeaderRow = {
  borderTop: "2px solid black",
  borderBottom: "2px solid black",
};

export const thProduct = {
  borderLeft: "2px solid black",
  borderRight: "2px solid black",
};

export const thBorderRight = {
  borderRight: "2px solid black",
};

export const tdLeftBordered = {
  borderLeft: "2px solid black",
  borderRight: "2px solid black",
};

export const tdLeftBold = {
  borderLeft: "2px solid black",
  fontWeight: 600,
  borderRight: "2px solid black",
};

export const tdBorderRight = {
  borderRight: "2px solid black",
};

export const tdBoldBorderRight = {
  fontWeight: 600,
  borderRight: "2px solid black",
};

export const finalTotalRow = {
  borderBottom: "2px solid black",
};

export const tbodyFullWidth = {
  width: "100%",
};
